import { GlobalStyles as MUIGlobalStyles } from "@mui/material";
import { alpha } from "@mui/material/styles";

export default function GlobalStyles() {
  return (
    <MUIGlobalStyles
      styles={{
        "*": {
          boxSizing: "border-box",
        },
        html: {
          margin: 0,
          padding: 0,
          width: "100%",
          height: "100%",
          WebkitOverflowScrolling: "touch",
        },
        body: {
          margin: 0,
          padding: 0,
          width: "100%",
          height: "100%",
        },
        "#__next": {
          width: "100%",
          height: "100%",
        },
        input: {
          "&[type=number]": {
            MozAppearance: "textfield",
            "&::-webkit-outer-spin-button": {
              margin: 0,
              WebkitAppearance: "none",
            },
            "&::-webkit-inner-spin-button": {
              margin: 0,
              WebkitAppearance: "none",
            },
          },
        },
        img: {
          display: "block",
          maxWidth: "100%",
        },
        ul: {
          margin: 0,
          padding: 0,
        },
        "*::-webkit-scrollbar": {
          width: 4,
          height: 4,
        },
        "*::-webkit-scrollbar-track": {
          backgroundColor: alpha("#323741", 0.07),
          borderRadius: 2,
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: alpha("#323741", 0.4),
          borderRadius: 3,
        },
      }}
    />
  );
}
